

























import Vue from 'vue';

export default Vue.extend({
	name: 'Speakers',
	data: function(){
		return {
			jury: [
				{ name:"Борис Болтянский", post:"Главный редактор Право.ru", img:"boltjanskiy.jpg" },
				{ name:"Евгения Червец", post:"Руководитель офиса Коллегии адвокатов «Регионсервис» в г. Москве, адвокат, консультант Исследовательского центра частного права имени С.С. Алексеева при Президенте РФ, магистр юриспруденции (РШЧП), LLM", img:"chervec.jpg" },
				{ name:"Мария Любимова", post:"Старший юрист, адвокат Коллегии адвокатов «Регионсервис», г. Москва, консультант Исследовательского центра частного права имени С.С. Алексеева при Президенте РФ, магистр юриспруденции (РШЧП)", img:"ljubimova.jpg" },
				{ name:"Александр Сарапин", post:"Исполнительный директор PravoTech", img:"sarapin.jpg" }
			],
			speakers: [
				{ name: "Владимир Ярков", post: "Д.ю.н., Профессор, Заведующий кафедрой гражданского процесса УрГЮУ, профессор Уральского отделения Исследовательского центра частного права имени С.С. Алексеева при Президенте РФ (РШЧП), приглашенный профессор Университета Париж Нантерр, член Международной ассоциации процессуального права, научного совета Международного союза судебных исполнителей, генерального совета Международного союза нотариата", img :"yarkov.jpg" },
				{ name: "Татьяна Стукалова", post: "Сопредседатель Коллегии адвокатов «Регионсервис», г. Москва, адвокат, к.ю.н., заместитель Президента Гильдии российских адвокатов", img :"stukalova.jpg" },
				{ name: "Андрей Переладов", post: "Сопредседатель Коллегии адвокатов «Регионсервис», г. Кемерово, адвокат, член Общественной палаты Кемеровской области – председатель комиссии по вопросам безопасности и взаимодействия с правоохранительными органами", img :"pereladov.jpg" },
				{ name:"Юрий Пилипенко", post:"Д.ю.н., профессор кафедры адвокатуры и нотариата Московского государственного юридического университета им. О. Е. Кутафина, президент Федеральной палаты адвокатов", img:"pilipenko.jpg" },
				{ name: "Елена Авакян", post: "Член Совета ФПА, советник ФПА РФ, исполнительный директор НП «Содействие развитию корпоративного законодательства», советник Адвокатского бюро «Егоров, Пугинский, Афанасьев и партнеры»", img :"avakjan.jpg" },
				{ name: "Алексей Солохин", post: "Преподаватель факультета повышения квалификации судей Российского государственного университета правосудия, советник Управления публичного права и процесса ВАС РФ (до августа 2014 года), эксперт по гражданскому и арбитражному процессам, исполнительному производству и альтернативным способам разрешения споров", img :"solohin.jpg" },
				{ name:"Константин Брановицкий", post:"Д.ю.н., магистр права (Киль, ФРГ), профессор кафедры гражданского процесса УрГЮУ", img:"branovitskiy.jpg" },
				{ name: "Роман Ходыкин", post: "Партнер лондонского офиса фирмы «Bryan Cave Leighton Paisner», солиситор Высших судов Англии и Уэльса, приглашенный профессор университета Королевы Марии (Queen Mary University), Лондон", img :"xodykin.jpg" },
				{ name: "Ольга Болтенко", post: "Преподаватель магистратуры арбитражного и инвестиционного права Университета Гонконга, партнер китайской юридической компании Fangda Partners (Фангда Партнерс), Гонконг", img :"boltenko.jpg" },
				{ name:"Александр Хвощинский", post:"LL.M, соучредитель и партнер консалтинговой компании Legal Stratagency (Берлин)", img: "hvoschinskiy.jpg" },
				{ name:"Бахыт Тукулов", post:"Партнер и руководитель практики Судебные споры в Казахстане, GRATA International", img:"tukulov.jpg"},
				{ name:"Ирина Обухова", post:"Адвокат, Глава Практики разрешения споров в Узбекистане, GRATA International", img:"obuhova.jpg" },
				{ name:"Михаил Шварц", post:"К.ю.н., профессор кафедры гражданского процесса СПбГУ, управляющий партнер Адвокатского бюро «Шварц и Партнеры»", img:"shvarc.jpg" },
				{ name: "Александр Ягельницкий", post: "Советник юридической фирмы Petrol Chilikov, доцент кафедры гражданского права МГУ им. М.В. Ломоносова, к.ю.н., магистр юриспруденции (РШЧП)", img :"jagelnickiy.jpg" },
				{ name: "Алексей Пелевин", post: "CEO PravoTech", img :"pelevin.jpg" },
				{ name: "Галина Виленская", post: "Начальник правового управления дирекции по юридическим вопросам ПАО «ГТЛК»", img :"vilenskaya.jpg" },
				{ name: "Евгений Акимов", post: "Управляющий директор, начальник управления принудительного взыскания и банкротства департамента по работе с проблемными активами ПАО «Сбербанк»", img :"akimov.jpg" },
				{ name: "Виктор Домшенко", post: "Руководитель отдела судебной защиты АО «Почта России», магистр юриспруденции (РШЧП)", img :"domshenko.jpg" },
				{ name: "Константин Гричанин", post: "Заместитель директора Департамента судебной практики НК Роснефть", img :"grichanin.jpg" },
				{ name: "Айс Лиджанова", post: "Старший юрист, адвокат Адвокатского бюро «Егоров, Пугинский, Афанасьев и партнеры»", img :"lidzhanova.jpg" },
				{ name: "Антон Еремеев", post: "Эксперт юридического департамента Банка ВТБ, магистр юриспруденции (РШЧП)", img :"eremeev.jpg" },
			]
		}
	}
});
